import { NgModule } from '@angular/core';

import { FileUploadComponent } from '@shared/modules/file-upload/file-upload.component';
import { CommonModule } from '@angular/common';
import { SpinnerModule } from '@shared/components/spinner/spinner.module';
import { DragZoneModule } from '@shared/modules/drag-zone/drag-zone.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [FileUploadComponent],
  imports: [CommonModule, SpinnerModule, DragZoneModule, MatIconModule],
  exports: [FileUploadComponent],
})
export class FileUploadModule {}
